export default {
  'menu.projects': '專案管理',
  'menu.projects.all': '全部專案',
  'menu.projects.participated': '我參與的',
  'menu.projects.following': '我關注的',
  'menu.projects.tagManagement': '標籤管理',
  'menu.estimationStandards': '工時評估標準管理',
  'menu.devAgents': '開發Agent管理',
  'menu.projectHome': '專案主頁',
  'menu.projectCharter': '專案約定',
  'menu.projectCharter.projectGoals': '目標願景',
  'menu.projectCharter.projectPrinciples': '原則要求',
  'menu.projectCharter.projectNotes': '注意事項',
  'menu.productInput': '產品輸入',
  'menu.productInput.inputDashboard': '輸入看板',
  'menu.productInput.issuesIdea': '想法/靈感',
  'menu.productInput.issuesRequest': '需求線索',
  'menu.productInput.referenceProducts': '參考產品',
  'menu.productInput.referenceMaterials': '資料引用',
  'menu.productInput.userFeedback': '使用者回饋',
  'menu.productInput.easyRecorder': '記錄易',
  'menu.requirementDefinition': '需求定義',
  'menu.requirementDefinition.summary': '概要需求',
  'menu.requirementDefinition.overviewTemplateManagement': '概要需求模板',
  'menu.requirementDefinition.featureList': '功能清單',
  'menu.requirementDefinition.roleAnalysis': '角色分析',
  'menu.requirementDefinition.conceptAnalysis': '概念分析',
  'menu.requirementDefinition.systemIntegration': '系統對接',
  'menu.requirementDefinition.document': '需求文檔',
  'menu.deliveryPlanning': '交付計劃',
  'menu.deliveryPlanning.issuesStory': '交付故事',
  'menu.deliveryPlanning.taskManagement': '任務管理',
  'menu.deliveryPlanning.estimationStandards': '估算標準',
  'menu.deliveryPlanning.taskListGeneration': '任務清單生成',
  'menu.developmentDesign': '研發設計',
  'menu.developmentDesign.applicationAnalysis': '應用分析',
  'menu.developmentDesign.repositoryManagement': '搭建應用',
  'menu.developmentDesign.modelingAssistant': '數據建模',
  'menu.developmentDesign.aiAssistedDesign': '原型設計',
  'menu.developmentDesign.architecture': '架構設計',
  'menu.developmentDesign.apiManagement': 'API 管理',
  'menu.developmentExecution': '研發執行',
  'menu.developmentExecution.agentManagement': 'Agent 管理',
  'menu.developmentExecution.codeRepository': '程式碼管理',
  'menu.developmentExecution.codeMigration': '程式碼遷移',
  'menu.testQuality': '測試質量',
  'menu.testQuality.testManagement': '測試管理',
  'menu.testQuality.issuesBug': '缺陷',
  'menu.testQuality.qualityAnalysis': '質量分析',
  'menu.projectAssets': '專案資產',
  'menu.projectAssets.assetLibrary': '素材庫',
  'menu.projectAssets.daily-report-management': '日報管理',
  'menu.projectAssets.quote-management': '報價管理',
  'menu.projectAssets.auditLog': '審計日誌',
  'menu.productionDashboard': '生產看板',
  'menu.projectDashboard': '生產看板',
  'menu.projectDashboard.dashboard': '生產看板',
  'menu.dailyManagement': '日常管理',
  'menu.dailyManagement.taskManagement': '任務管理',
  'menu.dailyManagement.communicationRecords': '溝通記錄',
  'menu.dailyManagement.issueTracker': '事項管理',
  'menu.dailyManagement.issueTracker.bug': 'Bug',
  'menu.dailyManagement.issueTracker.userFeedback': '使用者回饋',
  'menu.dailyManagement.issueTracker.risk': '風險',
  'menu.dailyManagement.issueTracker.problem': '問題',
  'menu.dailyManagement.issueTracker.changeRequest': '變更請求',
  'menu.dailyManagement.issueTracker.pendingConfirmation': '待確認事項',
  'menu.dailyManagement.dailyReportManagement': '日報管理',
  'menu.requirementAnalysis': '需求分析',
  'menu.requirementAnalysis.requirementPool': '需求池',
  'menu.requirementAnalysis.structuredAnalysis': '結構化分析',
  'menu.requirementAnalysis.highLevelRequirements': '概要需求',
  'menu.requirementAnalysis.featureList': '功能清單',
  'menu.requirementAnalysis.prd': '需求文檔',
  'menu.prototypeDesign': '原型設計',
  'menu.prototypeDesign.brandDesign': '品牌設計',
  'menu.prototypeDesign.uiGuidelines': 'UI規範',
  'menu.prototypeDesign.informationArchitecture': '資訊架構',
  'menu.prototypeDesign.menuPlanning': '選單規劃',
  'menu.prototypeDesign.pageDesign': '頁面設計',
  'menu.prototypeDesign.interactionFlow': '互動流程',
  'menu.prototypeDesign.aiAssistedDesign': 'AI頁面設計',
  'menu.prototypeDesign.prototypePreview': '原型預覽',
  'menu.architectureDesign': '架構設計',
  'menu.architectureDesign.architectureOverview': '架構總覽',
  'menu.architectureDesign.applicationArchitecture': '應用架構',
  'menu.architectureDesign.technicalStandards': '技術規範',
  'menu.architectureDesign.dataModeling': '數據建模',
  'menu.architectureDesign.apiDesign': '介面設計',
  'menu.architectureDesign.permissionModel': '權限模型',
  'menu.architectureDesign.integrationDesign': '整合設計',
  'menu.architectureDesign.adr': '架構決策',
  'menu.developmentExecution.applicationManagement': '應用管理',
  'menu.developmentExecution.developmentTasks': '開發任務',
  'menu.developmentExecution.codeManagement': '程式碼管理',
  'menu.developmentExecution.codeActivity': '程式碼活動',
  'menu.developmentExecution.buildRecords': '建置記錄',
  'menu.agentsManagement': 'Agents管理',
  'menu.agentsManagement.agentWorkspace': 'Agent工作台',
  'menu.agentsManagement.projectAgents': '專案Agents',
  'menu.testingQuality': '測試質量',
  'menu.testingQuality.testingOverview': '測試概覽',
  'menu.testingQuality.testPlan': '測試計劃',
  'menu.testingQuality.testCases': '測試用例',
  'menu.testingQuality.testExecution': '測試執行',
  'menu.testingQuality.qualityAnalysis': '質量分析',
  'menu.testingQuality.acceptanceManagement': '驗收管理',
  'menu.deploymentOperations': '部署運維',
  'menu.deploymentOperations.console': '部署控制台',
  'menu.deploymentOperations.pipelines': '流水線記錄',
  'menu.deploymentOperations.runtime': '運行監控',
  'menu.deploymentOperations.coralApplicationPublication': '應用上架',
  'menu.releaseDelivery': '發布交付',
  'menu.releaseDelivery.versionManagement': '版本管理',
  'menu.releaseDelivery.releasePlan': '發布計劃',
  'menu.releaseDelivery.releaseRecords': '發布記錄',
  'menu.releaseDelivery.deliverablesManagement': '交付物管理',
  'menu.releaseDelivery.coralApplicationPublication': '應用上架',
  'menu.researchReferences': '資料研究',
  'menu.researchReferences.referenceMaterials': '參考資料',
  'menu.researchReferences.competitorManagement': '競品管理',
  'menu.researchReferences.competitorAnalysis': '競品分析',
  'menu.researchReferences.competitorAnalysisReport': '競品分析報告',
  'menu.buildingAssets': '搭建輔助',
  'menu.buildingAssets.imageAssets': '圖片素材',
  'menu.buildingAssets.iconAssets': '圖標素材',
  'menu.projectAssets.projectDocuments': '專案文檔',
  'menu.projectAssets.deliverables': '交付物',
  'menu.businessManagement': '商務管理',
  'menu.businessManagement.quotationManagement': '報價管理',
  'menu.businessManagement.contractInformation': '合約資訊',
  'menu.businessManagement.paymentPlan': '回款計劃',
  'menu.businessManagement.changeQuotation': '變更報價',
  'menu.projectSettings.memberManagement': '成員管理',
  'menu.projectSettings.projectDetail': '專案詳情',
  'menu.projectSettings.auditLogs': '審計日誌',
  'menu.projectSettings.projectAnnouncements': '專案公告',
  'menu.projectGoals': '專案約定',
  'menu.projectCollection': '專案整體',
  'menu.projectCollection.projectHome': '專案主頁',
  'menu.projectCollection.projectGoals': '專案約定',
  'menu.applicationManagement': '應用管理',
  'menu.applicationManagement.repositoryManagement': '搭建應用',
  'menu.applicationManagement.applicationAnalysis': 'AI應用分析',
  'menu.application': '應用管理',
  'menu.communication': '溝通記錄',
  'menu.requirements': '需求分析',
  'menu.requirements.requirementPool': '需求池',
  'menu.requirements.summary': '需求概要',
  'menu.requirements.featureList': '功能清單',
  'menu.requirements.document': '需求文檔',
  'menu.requirements.roleAnalysis': '角色分析',
  'menu.requirements.conceptAnalysis': '概念分析',
  'menu.requirements.conceptAnalysis.management': '概念管理',
  'menu.requirements.conceptAnalysis.group': '概念分組',
  'menu.requirements.conceptAnalysis.relation': '概念關係',
  'menu.conceptAnalysis': '概念分析',
  'menu.conceptAnalysis.management': '概念管理',
  'menu.conceptAnalysis.group': '概念分組',
  'menu.conceptAnalysis.relation': '概念關係',
  'menu.requirements.applicationAnalysis': 'AI應用分析',
  'menu.requirements.projectGoals': '專案約定',
  'menu.dataModeling': '數據建模',
  'menu.dataModeling.modelingAssistant': 'AI輔助建模',
  'menu.dataModeling.entityManagement': '實體管理',
  'menu.dataModeling.ruleManagement': '規則管理',
  'menu.dataModeling.dataSourceManagement': '數據源管理',
  'menu.requirements.systemIntegration': '系統對接',
  'menu.prototype': '頁面設計',
  'menu.prototype.aiAssistedDesign': 'AI頁面設計',
  'menu.prototype.statisticalAnalysisPageDesign': '統計分析頁面設計',
  'menu.prototype.bigScreenPageDesign': '大屏頁面設計',
  'menu.prototype.designManagement': '頁面管理',
  'menu.prototype.themeDesign': '主題設計',
  'menu.architecture': '架構設計',
  'menu.architecture.overview': '概要設計',
  'menu.architecture.detail': '詳細設計',
  'menu.agentManagement': 'Agent管理',
  'menu.developmentManagement': '開發管理',
  'menu.developmentManagement.agentManagement': 'Agent管理',
  // 'menu.developmentManagement.devAgentV1Planning': '開發智能體 V1 任務計劃',
  // 'menu.developmentManagement.devAgentV1': '開發智能體 V1 運行看板',
  // 'menu.developmentManagement.projectBlueprint': '專案藍圖',
  'menu.developmentManagement.taskManagement': '開發任務管理',
  'menu.architecture.codeManagement': '程式碼管理',
  'menu.architecture.apiManagement': '介面管理',
  'menu.codeManagement': '程式碼管理',
  'menu.codeManagement.codeRepository': '程式碼倉庫',
  'menu.codeManagement.codeMigration': '程式碼遷移',
  'menu.codeManagement.dependencyAnalysis': '依賴分析',
  'menu.apiManagement': '介面管理',
  'menu.apiManagement.apiList': '介面列表',
  'menu.apiManagement.apiQuickDebug': '介面快速調試',
  'menu.testManagement': '測試管理',
  'menu.testManagement.dashboard': '儀表板',
  'menu.testManagement.bug': 'BUG',
  'menu.testManagement.case': '用例',
  'menu.testManagement.suite': '套件',
  'menu.testManagement.order': '測試單',
  'menu.testManagement.report': '測試報告',
  'menu.testManagement.caseLibrary': '用例庫',
  'menu.qualityManagement': '質量管理',
  'menu.qualityManagement.qualityAnalysis': '質量分析',
  'menu.knowledgeBase': '資料引用',
  'menu.knowledgeBase.referenceProducts': '參考產品',
  'menu.knowledgeBase.referenceMaterials': '資料引用',
  'menu.assetLibrary': '素材庫',
  'menu.projectSettings': '專案設定',
  'menu.projectSettings.projectMember': '專案與成員',
  'menu.projectSettings.projectCollaboration': '專案協同',
  'menu.projectSettings.projectAnnouncement': '專案公告',
  'menu.projectSettings.projectTags': '專案標籤',
  'menu.projectSettings.developerOptions': '開發者選項',
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '管理頁',
  'menu.admin.sub-page': '二級管理頁',
  'menu.system': '系統管理',
  'menu.system.menu': '菜單管理',
  'menu.system.user': '用戶管理',
  'menu.system.role': '角色管理',
  'menu.template': '模板示例',
  'menu.login': '登錄',
  'menu.register': '註冊',
  'menu.register-result': '註冊結果',
  'menu.dashboard': '儀表板',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬資訊）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬資訊）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標準列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（專案）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '異常頁',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '觸發錯誤',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
  'menu.auditLog': '審計日誌',
  'menu.tabs.refresh': '刷新當前頁籤',
  'menu.tabs.closeCurrent': '關閉當前頁籤',
  'menu.tabs.closeOthers': '關閉其他頁籤',
  'menu.tabs.closeRight': '關閉右側頁籤',
  'menu.tabs.closeAll': '關閉全部頁籤',
  'menu.tabs.scrollLeft': '向左查看頁籤',
  'menu.tabs.scrollRight': '向右查看頁籤',
  'menu.tabs.manage': '頁籤管理',
  'menu.tabs.unnamed': '未命名頁面',
  // legacy keys for backward compatibility
  'menu.项目管理': '專案管理',
  'menu.工时评估标准管理': '工時評估標準管理',
  'menu.开发Agent管理': '開發Agent管理',
  'menu.项目列表': '專案列表',
  'menu.项目主页': '專案主頁',
  'menu.应用管理': '應用管理',
  'menu.应用管理.搭建应用': '搭建應用',
  'menu.沟通记录': '溝通記錄',
  'menu.需求分析': '需求分析',
  'menu.需求分析.需求概要': '需求概要',
  'menu.需求分析.功能清单': '功能清單',
  'menu.需求分析.需求文档': '需求文檔',
  'menu.页面设计': '頁面設計',
  'menu.架构设计': '架構設計',
  'menu.架构设计.概要设计': '概要設計',
  'menu.架构设计.详细设计': '詳細設計',
  'menu.任务管理': '任務管理',
  'menu.缺陷管理': '缺陷管理',
  'menu.测试管理': '測試管理',
  'menu.质量管理': '質量管理',
  'menu.日报管理': '日報管理',
  'menu.报价管理': '報價管理',
  'menu.知识库': '參考資料',
  'menu.素材库': '素材庫',
  'menu.审计日志': '審計日誌',
  'menu.需求分析.角色分析': '角色分析',
  'menu.需求分析.概念分析': '概念分析',
  'menu.需求分析.应用分析': 'AI應用分析',
  'menu.需求分析.项目目标': '專案約定',
  'menu.需求分析.数据建模': '數據建模',
  'menu.数据建模.AI辅助建模': 'AI輔助建模',
  'menu.数据建模.实体管理': '實體管理',
  'menu.需求分析.系统对接': '系統對接',
  'menu.taskManagement': '任務管理',
  'menu.defectManagement': '缺陷管理',
  'menu.daily-report-management': '日報管理',
  'menu.quote-management': '報價管理',
};
